export default {
    site_title: "Muzeum Ustrońskie"
};